import { render, staticRenderFns } from "./TableCellRedirectsTargetUrl.vue?vue&type=template&id=c2611a86&scoped=true"
import script from "./TableCellRedirectsTargetUrl.vue?vue&type=script&lang=js"
export * from "./TableCellRedirectsTargetUrl.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2611a86",
  null
  
)

export default component.exports